export default __webpack_public_path__ + "static/media/iso.bd4a28e9.png";